<div id="annotation-window" (scroll)="scrollHandler($event)">
  <div id="pdf-container" *ngIf="allowPdfLoad === true">
    <pdf-viewer
      [src]="fileUrl"
      [render-text]="false"
      [original-size]="true"
      [show-all]="false"
      [zoom]="zoom"
      [(page)]="pdfCurrentPage"
      (after-load-complete)="afterPdfLoadComplete($event)"
      (page-rendered)="pdfPageRendered($event)"
      class="w-full h-full relative"
    >
    </pdf-viewer>
  </div>
  <div id="konva-holder" [ngClass]="{ hidden: allowPdfLoad === false }"></div>
</div>

<div class="media-asset-toolbar">
  <ul class="media-asset-toolbar-list media-asset-toolbar-area" i18n-aria-label="PDF view">
    <li class="media-asset-toolbar-item">
      <button mat-icon-button (click)="zoomPDF(1)" [disabled]="zoom === maxZoom">
        <mat-icon class="material-icons-outlined">zoom_in</mat-icon>
      </button>
    </li>

    <li class="media-asset-toolbar-item">
      <button mat-icon-button (click)="zoomPDF(-1)" [disabled]="zoom === minZoom">
        <mat-icon class="material-icons-outlined">zoom_out</mat-icon>
      </button>
    </li>

    <li class="media-asset-toolbar-item">
      <button mat-icon-button (click)="openAssetFullscreen()">
        <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
      </button>
    </li>
  </ul>

  <ul class="media-asset-toolbar-list media-asset-toolbar-area grid-area-center pager-single" i18n-aria-label="PDF page navigation">
    <li class="media-asset-toolbar-item grid-area-start">
      <button mat-icon-button (click)="previousPage()" [disabled]="pdfCurrentPage === 1 || isPrevNextDisabled">
        <mat-icon>navigate_before</mat-icon>
      </button>
    </li>

    <li class="media-asset-toolbar-item grid-area-center">
      <span>{{ pdfCurrentPage }} of {{ totalPdfPages }}</span>
    </li>

    <li class="media-asset-toolbar-item grid-area-end">
      <button mat-icon-button (click)="nextPage()" [disabled]="pdfCurrentPage === totalPdfPages || isPrevNextDisabled">
        <mat-icon>navigate_next</mat-icon>
      </button>
    </li>
  </ul>
</div>
